import React from 'react'
import { withRouter } from 'react-router'

const Page = ({ children, className, location }) => {
    // console.log(location.pathname, !!~location.pathname.indexOf('/article/edit'))
    return (
        <div className={"page mb-5 "+(!~location.pathname.indexOf('/article/edit')&&'container '||'container-fluid px-3 ')+className}>
            <div className="row">
                <div className="col-12">
                    {children}
                </div>
            </div>
        </div>
    )
}

export default withRouter(Page)
